import React from 'react';
import { PartnerMyInfoPage } from '../components/integration/PartnerMyInfoPage';

interface UserInfo {
  username: string;
  displayName: string;
  role: string;
  orgName: string;
  orgIcon: string;
  loginTime: string;
}

export default function KULSMyInfo({ user }: { user: UserInfo }) {
  return <PartnerMyInfoPage partner="KULS" user={user} />;
}
